import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Banner from './components/Banner';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProgramsPage from './pages/ProgramsPage';
import ImpactPage from './pages/ImpactPage';
import ApplyPage from './pages/ApplyPage';
import ContactPage from './pages/ContactPage';
import ENewsPage from './pages/ENewsPage';
import ArticlePage from './pages/ArticlePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import RSSFeed from './pages/RSSFeed';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
export function App() {
  return <AuthProvider data-id="element-0">
      <Router data-id="element-1">
        <div className="flex flex-col min-h-screen" data-id="element-2">
          <Navbar data-id="element-3" />
          <Banner data-id="element-4" />
          <main className="flex-grow" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<HomePage data-id="element-8" />} data-id="element-7" />
              <Route path="/about" element={<AboutPage data-id="element-10" />} data-id="element-9" />
              <Route path="/programs" element={<ProgramsPage data-id="element-12" />} data-id="element-11" />
              <Route path="/impact" element={<ImpactPage data-id="element-14" />} data-id="element-13" />
              <Route path="/apply" element={<ApplyPage data-id="element-16" />} data-id="element-15" />
              <Route path="/contact" element={<ContactPage data-id="element-18" />} data-id="element-17" />
              <Route path="/enews" element={<ENewsPage data-id="element-20" />} data-id="element-19" />
              <Route path="/enews/:articleId" element={<ArticlePage data-id="element-22" />} data-id="element-21" />
              <Route path="/login" element={<LoginPage data-id="element-24" />} data-id="element-23" />
              <Route path="/rss" element={<RSSFeed data-id="element-26" />} data-id="element-25" />
              <Route path="/dashboard/*" element={<ProtectedRoute data-id="element-28">
                    <DashboardPage data-id="element-29" />
                  </ProtectedRoute>} data-id="element-27" />
            </Routes>
          </main>
          <Footer data-id="element-30" />
        </div>
      </Router>
    </AuthProvider>;
}